import '@react95/core/GlobalStyle';
import '@react95/core/themes/win95.css';

import { TaskBar, List } from '@react95/core';
import { Phone2, Grpconv100, Progman34, Awfxcg321303, Progman14, Computer4 } from '@react95/icons';
import { DosGameWindow } from './Components/DosGameWindow';
import { DesktopItem } from './Components/DesktopItem';
import { useState, useRef, useEffect } from 'react';
import { Contact } from './Components/Contact';
import { Resume } from './Components/Resume';
import { Coding } from './Components/Coding';
import { Credits } from './Components/Credits';

import { useTranslation } from 'react-i18next';

export default function PcDisplay() {
  const { t, i18n } = useTranslation();

  const taskBarRef = useRef(null);

  useEffect(() => {
    if (!taskBarRef.current) return;
    const walker = document.createTreeWalker(taskBarRef.current, NodeFilter.SHOW_TEXT, null, false);

    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue.includes('Start')) {
        node.nodeValue = node.nodeValue.replace('Start', t('windows.start'));
      }
      if (node.nodeValue.includes('Inicio')) {
        node.nodeValue = node.nodeValue.replace('Inicio', t('windows.start'));
      }
    }
  }, [t, i18n.language]);

  const [desktopItems] = useState([
    {
      id: 'resume',
      icon: <Progman34 variant="32x32_4" />,
      content: () => <Resume />,
      showOnDesktop: true,
      showInTaskbar: false,
    },
    {
      id: 'coding',
      icon: <Grpconv100 variant="32x32_4" />,
      content: () => <Coding />,
      showOnDesktop: true,
      showInTaskbar: false,
    },
    {
      id: 'contact',
      icon: <Phone2 variant="32x32_4" />,
      content: () => <Contact />,
      showOnDesktop: true,
      showInTaskbar: false,
    },
    {
      id: 'karateka',
      icon: (
        <img
          alt="karateka"
          src="icons/karateka.webp"
          className="w-[32px] h-[auto] r95_1ct83mo9 object-contain object-left"
        />
      ),
      content: () => <DosGameWindow url="/js-dos/Karateka.jsdos" />,
      showOnDesktop: true,
      showInTaskbar: false,
    },
    {
      id: 'source',
      icon: <Progman14 variant="32x32_4" />,
      action: () => {
        window.open('https://github.com/moemmia/moemmia.github.io', '_blank');
      },
      showOnDesktop: false,
      showInTaskbar: true,
    },
    {
      id: 'credits',
      icon: <Awfxcg321303 variant="32x32_4" />,
      content: () => <Credits />,
      showOnDesktop: false,
      showInTaskbar: true,
    },
  ]);

  const [openItems, setOpenItems] = useState(['resume']);
  const [zOrder, setZOrder] = useState([]);

  const handleOpen = id => {
    setOpenItems(prev => (prev.includes(id) ? prev : [...prev, id]));
    bringToFront(id);
  };

  const handleClose = id => {
    setOpenItems(prev => prev.filter(item => item !== id));
    setZOrder(prev => prev.filter(item => item !== id));
  };

  const bringToFront = id => {
    setZOrder(prev => [...prev.filter(item => item !== id), id]);
  };

  return (
    <div className="w-full h-full bg-[#5aa] relative overflow-hidden">
      {/* Icons */}
      <div className="absolute inset-0 p-4 grid grid-cols-7 grid-rows-7 gap-x-8 gap-y-8 grid-flow-col">
        {desktopItems
          .filter(item => item.showOnDesktop)
          .map(item => (
            <div
              key={item.id}
              className="flex flex-col items-center cursor-pointer"
              onClick={() => handleOpen(item.id)}
            >
              <div>{item.icon}</div>
              <span className="text-xs mt-1 select-none">{t(`windows.${item.id}`)}</span>
            </div>
          ))}
      </div>

      {/* TaskBar */}
      <TaskBar
        ref={taskBarRef}
        list={
          <List>
            {desktopItems
              .filter(item => item.showInTaskbar)
              .map(item => (
                <List.Item
                  key={item.id}
                  icon={item.icon}
                  onClick={() => {
                    handleOpen(item.id);
                    item.action?.();
                  }}
                >
                  {t(`windows.${item.id}`)}
                </List.Item>
              ))}
            <List.Divider></List.Divider>
            <List.Item icon={<Computer4 variant="32x32_4" />} onClick={() => {}}>
              {t('windows.shut')}
            </List.Item>
          </List>
        }
      />

      {/* Windows */}
      {desktopItems.map(item => (
        <DesktopItem
          key={item.id}
          item={item}
          isOpen={openItems.includes(item.id)}
          onClose={() => handleClose(item.id)}
          onFocus={() => bringToFront(item.id)}
          zIndex={zOrder.indexOf(item.id) + 100}
        />
      ))}

      {/* Version Number */}
      <p className="absolute top-0 right-0 m-1.5 text-white opacity-30 pointer-events-none">
        v {process.env.REACT_APP_VERSION}
      </p>
    </div>
  );
}
